export class CustomError extends Error {
  readonly data: unknown;

  constructor({ message = 'Unknown Error.', data, name = 'UNKNOWN_ERROR' }: { message?: string; data?: unknown; name?: string } = {}) {
    super(message);
    this.data = data;
    this.name = name;

    Object.setPrototypeOf(this, CustomError.prototype);
  }
}
